'use client';

import config from '@/config';
import { ArrowRight } from 'lucide-react';
import mixpanel from 'mixpanel-browser';

const tryFreeHref = `${config.appUrl}/register?corporate=true`;

export default function BusinessCTA() {
  return (
    <section className="relative overflow-hidden min-h-[70vh] flex items-center bg-ink-900">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, #FDFAF3 1px, transparent 0)',
          backgroundSize: '20px 20px',
        }}
      />

      <div className="relative py-24 lg:py-32 px-6 lg:px-8 w-full">
        <div className="max-w-3xl mx-auto text-center">
          <p className="font-hand text-brand-300 text-2xl mb-3 rotate-1 inline-block">
            ready when you are
          </p>
          <h2 className="font-display font-black text-5xl md:text-7xl tracking-[-0.02em] text-paper-50 leading-[1.02] mb-7">
            See it on your
            <br />
            <span className="italic font-normal text-brand-300">
              own content.
            </span>
          </h2>
          <p className="font-display text-lg text-paper-50/80 mb-10 max-w-2xl mx-auto leading-relaxed">
            Book a 30-minute call and we will turn one of your existing modules
            into a live QuizWhizzer session, on the call.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              className="btn btn-primary btn-lg rounded-full px-8 text-white btn-letterpress"
              href={config.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                mixpanel.track('business_book_demo_clicked', {
                  location: 'cta_section',
                })
              }
            >
              Book a demo
              <ArrowRight className="w-5 h-5" />
            </a>
            <a
              className="btn btn-ghost btn-lg rounded-full px-8 text-paper-50 border-2 border-paper-50 hover:bg-paper-50 hover:text-ink-900 transition-colors"
              href={tryFreeHref}
              onClick={() =>
                mixpanel.track('business_try_free_clicked', {
                  location: 'cta_section',
                })
              }
            >
              Try it free
            </a>
          </div>

          <p className="font-hand text-paper-50/60 text-lg mt-6">
            Free for teams up to 10 · no credit card
          </p>
        </div>
      </div>
    </section>
  );
}
